import { render } from "./List.vue?vue&type=template&id=cf5909f6&scoped=true"
import script from "./List.vue?vue&type=script&lang=js"
export * from "./List.vue?vue&type=script&lang=js"

import "./List.vue?vue&type=style&index=0&id=cf5909f6&scoped=true&lang=scss"
script.render = render
script.__scopeId = "data-v-cf5909f6"

export default script